
import ChannelOnlineStatusHandler from "./channel-online-status-handler.vue";
export default {
  props: {
    channels: {
      type: Array,
      default: () => []
    },
    brand: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ChannelOnlineStatusHandler
  }
};
